document.addEventListener("DOMContentLoaded", function() {
  // Find the button that triggers the True Fit popup
  const trueFitButton = document.querySelector('.truefit-btn'); // Adjust the selector to match your button's class or ID

  if (trueFitButton) {
    trueFitButton.addEventListener('click', function() {
      // Find the True Fit widget
      const trueFitWidget = document.querySelector('tf-product-widget');

      if (trueFitWidget) {
        // Open the True Fit popup and retrieve the style ID
        const styleId = trueFitWidget.getAttribute('styleid');
        console.log('Opening True Fit popup with Style ID:', styleId);

        // Tracking event with GTM
        trackPopupOpen(styleId);
      }
    });
  }

  // GTM tracking function
  function trackPopupOpen(styleId) {
    // Push event to the GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'truefit_popup_open',  // Custom event name
      eventCategory: 'TrueFit',
      eventLabel: styleId,  // Sending style ID as event label
      eventAction: 'open_popup',  // Action name
      styleId: styleId // Optional, if you want to track this as a variable in GTM
    });

    console.log('Event pushed to dataLayer:', {
      event: 'popup_open',
      eventCategory: 'TrueFit',
      eventLabel: styleId,
      eventAction: 'open_popup',
      styleId: styleId
    });
  }
});
